module.exports = __webpack_public_path__ + "img/detector-smoke.f8e98a71.svg";